import { Helmet } from "react-helmet-async";
import {
  SITE_URL,
  SITE_NAME,
  DEFAULT_IMAGE,
  DEFAULT_TITLE,
  DEFAULT_DESCRIPTION,
  normalizePath,
} from "../../seo/routes";

const ROBOTS_INDEX =
  "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";
const ROBOTS_NOINDEX = "noindex, follow";

export default function SEO({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  imageAlt = SITE_NAME,
  path = "/",
  type = "website",
  noindex = false,
  jsonLd = [],
}) {
  const cleanPath = normalizePath(path);
  const canonical = `${SITE_URL}${cleanPath === "/" ? "/" : cleanPath}`;

  return (
    <Helmet prioritizeSeoTags defer={false}>
      <html lang="fr" />
      <title>{title}</title>

      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? ROBOTS_NOINDEX : ROBOTS_INDEX} />
      {!noindex && <link rel="canonical" href={canonical} />}

      {/* Open Graph (Facebook, WhatsApp, LinkedIn…) */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={imageAlt} />

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={imageAlt} />

      {/* Données structurées schema.org */}
      {jsonLd.map((data, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
}
